<template>
	<div class="container">
		<div class="content">
			<div class="circle-title" v-if="userId">粉丝列表<span class="circle-title-bg"></span></div>
			<div class="ub ub-pj item-user mt-2" v-for="(item, index) in listUser" :key="index" @click="toDetail(item.id)">
				<div class="user-l ub ub-ac">
						<div class="tltleIndex">{{item.orderNum}}</div>
						<img class="ml-1" :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
						<div class="tltleName ml-1">{{item.nickName}}</div>
						<div class="level" v-if="item.circleLevel">
								<img :src="item.circleLevel">
						</div>
				</div>
		</div>
		<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
import Pagination from '@/components/pagination'
import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'UserInfoCirclList',
		components: {
			Pagination
		},
		data(){
			return {
				circleUserId: '',
				listUser: [],
				userId: '',
				pageSize: 10,
				pageNum: 1,
				total: 0
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.circleUserId = this.$route.query.userId
			if(this.userId) {
				this.getList()
			}
		},
		methods: {
			pageChange(e) {
					this.listUser = []
					this.pageNum = e.number
					this.getList()
			},
			toDetail(id){
				this.$router.push({
					path: '/userIndex?id='+id
				})
			},
			//获取加入的圈子
			async getList(){
				let param = {
					userId: this.userId,
					otherUserId: this.circleUserId,
					pageSize:this.pageSize,
					pageNum: this.pageNum
				}
				ajaxParam(param)
				const res = await post('v1/circle/otherFansList', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					this.listUser = list
					this.totol = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.container{
		width: 1200px;
		margin: 20px auto;
		box-sizing: border-box;

		.content {
			padding: 0 40px;
			background: #fff;
			border-radius: 20px;
			.circle-title{
				height: 40px;
				border-bottom: 1px solid rgba(50, 50, 51, 0.14);
				line-height: 40px;
				font-weight: bold;
				position: relative;
				margin-bottom: 15px;
				.circle-title-bg{
					position: absolute;
					left: 0;
					bottom: 0;
					width: 56px;
					height: 4px;
					background: #DD0515;
				}
			}
			.item-user{
				cursor: pointer;
        .tltleIndex{
            font-size: 16px;
            font-weight: 500;
            color: #333;
        }
        img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
        .user-r{
            text-align: center;
            font-size: 14px;
            color: #666;
        }
    }
		}
	}
</style>
